import styles from './card_list.module.scss';
import React from 'react';

interface OwnProps {
    children: React.ReactNode;
}
export function CardList({children}: OwnProps) {
    return <div className={styles.card_list}>{children}</div>;
}
